//#region imports

// react
import React, { useState } from 'react';

// custom components
import { Modal } from '_atoms';
import ChangeTableModal from './change-table-modal';

// styling
import { Colors, Spacing } from '_styles';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectTableNumber } from '_redux/slices/marketplace/user-marketplace';
import { selectOneRetailer } from '_redux/slices/marketplace/retailer';

//#endregion imports

const RetailerConfirmationModal = (props) => {

    //#region local states
    const [showChangeTableModal, setShowChangeTableModal] = useState(false);
    //#endregion local states

    //#region handlers
    const handleDone = () => props.done();
    const handleChangeTable = () => setShowChangeTableModal(true);
    //#endregion handlers

    //#region redux
    const dispatch = useDispatch();
    const retailerInfo = useSelector(selectOneRetailer);
    const tableNumber = useSelector(selectTableNumber);
    //#endregion redux

    return (
        <div style={{
            padding: Spacing.SCALE_12,
            width: '100%',
            maxWidth: '700px',
            borderRadius: Spacing.SCALE_12,
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            backgroundColor: '#fff',
        }}>

            {/* Header and Close Button */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: Spacing.SCALE_16,
            }}>
                <h5 style={{ margin: 0, fontWeight: 'bold', fontSize: 18 }}>Confirm Table Number</h5>
                <button
                    onClick={handleDone}
                    style={{
                        background: 'none',
                        border: 'none',
                        fontSize: 24,
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        color: '#888',
                        lineHeight: 1,
                    }}
                    aria-label="Close modal"
                >
                    &times;
                </button>
            </div>

            {/* Body */}
            <div style={{ marginBottom: Spacing.SCALE_16 }}>
                <p style={{ marginBottom: 8 }}>Welcome to <b>{retailerInfo?.retailerName}</b></p>
                <p style={{ marginBottom: 8 }}>Please confirm you are at: <strong>Table {tableNumber}</strong></p>
                <p style={{ color: Colors.GRAY_DARK, fontStyle: 'italic', fontSize: 14 }}>
                    This helps your server find the correct table.
                </p>
            </div>

            {/* Buttons */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: Spacing.SCALE_12 }}>
                <button
                    onClick={handleDone}
                    style={{
                        padding: `${Spacing.SCALE_10}px ${Spacing.SCALE_16}px`,
                        backgroundColor: Colors.PRM_LIGHT_BLUE,
                        color: 'white',
                        border: 'none',
                        borderRadius: Spacing.SCALE_6,
                        fontWeight: 'bold',
                        cursor: 'pointer',
                    }}
                >
                    Yes, that's my table
                </button>

                <button
                    onClick={handleChangeTable}
                    style={{
                        background: 'none',
                        border: 'none',
                        color: Colors.PRM_LIGHT_BLUE,
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        fontSize: 14,
                    }}
                >
                    I need to change my table
                </button>
            </div>

            {showChangeTableModal && (
                <Modal>
                    <ChangeTableModal done={() => setShowChangeTableModal(false)} />
                </Modal>
            )}
        </div>
    );
};

export default RetailerConfirmationModal;
